import { render, staticRenderFns } from "./CompTable.vue?vue&type=template&id=85f8be32&scoped=true"
import script from "./CompTable.vue?vue&type=script&lang=js"
export * from "./CompTable.vue?vue&type=script&lang=js"
import style0 from "./CompTable.vue?vue&type=style&index=0&id=85f8be32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f8be32",
  null
  
)

export default component.exports